export const accountTypesENUM = {
  CURRENT: "CURRENT_ACCOUNT",
  SAVINGS: "SAVINGS_ACCOUNT",
  PAYMENT: "PAYMENT_ACCOUNT",
};
